import {GameStatusType} from '@/stores/GameStatusStore/GameStatusStore.constants';

export class GameStatusMocks {
  // private isFetchStatus: boolean = false;

  public getStatus = (): GameStatusType => {
    // const status = this.isFetchStatus ? GameStatusType.LeaguesRecalculation : GameStatusType.Active;
    // this.isFetchStatus = !this.isFetchStatus;

    return GameStatusType.Mocks;
  };
}
